export default "__VITE_ASSET__LD7_o2qe__"